var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "dialogo dialogo_ativo dialogo_medio" }, [
      _c("div", { staticClass: "dialogo__container" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "dialogo__botao-fechar",
            attrs: { type: "button", "aria-label": "Fechar diálogo" },
            on: {
              click: function($event) {
                return _vm.$emit("fecharModal")
              }
            }
          },
          [
            _c("i", {
              staticClass: "far fa-times",
              attrs: { "aria-label": "hidden" }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dialogo__cabecalho" }, [
      _c("h2", { staticClass: "dialogo__titulo u-margem-inferior-mini" }, [
        _vm._v("Onde encontrar o número de contrato no boleto")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dialogo__corpo" }, [
      _c(
        "div",
        { staticClass: "grade__linha grade__linha_alinhar-vertical-centro" },
        [
          _c("img", {
            staticClass: "comprovante-pagamento",
            attrs: {
              src: "/Administracao/Content/images/numero-do-contrato.png"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grade__linha" }, [
        _c("p", [
          _vm._v(
            "Caso não tenha algum boleto em mãos entre em contato com a Agehab pelo telefone "
          ),
          _c("strong", [_vm._v("0800-647-3120")]),
          _vm._v(" das 8 às 13 horas.")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d6edf34", { render: render, staticRenderFns: staticRenderFns })
  }
}